import React from 'react'
import PropTypes from 'prop-types'

import Loader from 'Pods/Shared/Loader'

import FeedItem from './FeedItem'

function FeedContainer({
  isDataFetched, notifications, meta, onPageChange,
}) {
  return (
    <div className="row feed-container">
      {!isDataFetched ? (
        <Loader isFullHeight />
      ) : (
        notifications.length === 0 ? (
          <div className="empty-content u-text-center">
            {
            meta.isMaintenance ? (
              <p className="text-semibold">
                Notifications center is currently under maintenance
              </p>
            ) : (
              <p className="text-semibold">
                Oops! You have no new notifications. Be active, upload and share your models or engage
                our <a href="/forum/boards/newest" className="link--primary-dark">community</a>.
              </p>
            )
          }
          </div>
        ) : (
          <div className="feed-container__content">
            {notifications.map((feedItem, index) => (
              <FeedItem
                checked={feedItem.attributes.checked}
                title={feedItem.attributes.bubble}
                body=""
                thumbnail={feedItem.attributes.thumbnail}
                fallbackThumbnail={feedItem.attributes.fallbackThumbnail}
                createdAt={feedItem.attributes.createdAt}
                category={feedItem.attributes.category}
                points={feedItem.attributes.points}
                key={`${feedItem.attributes.thumbnail}-${index}`}
              />
            ))}
            {notifications.length >= 7
             && (
             <button className="btn btn-transparent btn-block btn-show-more" onClick={onPageChange}>
               {meta.per_page === 7 ? 'show more' : 'show less'}
             </button>
             )
          }
          </div>
        ))}
    </div>
  )
}

FeedContainer.propTypes = {
  isDataFetched: PropTypes.bool.isRequired,
  notifications: PropTypes.array.isRequired,
  meta: PropTypes.object.isRequired,
  onPageChange: PropTypes.func.isRequired,
}

export default FeedContainer
